import React, { useState } from "react"
import classNames from "classnames"
import PropTypes from "prop-types"
import hiddenImg from "../../../images/icons/password-show.png"
import showImg from "../../../images/icons/password-hidden.png"

import { isEmpty } from "../../../helpers/validator"

const TextBox = ({
	input,
	type,
	isError,
	label,
	className,
	secondary,
	labelClassName,
	disabled,
	required,
	hideLabel,
	readOnly,
	pattern,
	maxField,
	isPassword,
	requiredIcon,
}) => {
	const [isShowPass, setIsShowPass] = useState(false)

	if (isPassword) {
		return (
			<div className="textbox-container">
				<div style={{ position: "relative" }}>
					{isPassword && (
						<div
							style={{
								position: "absolute",
								right: 0,
								bottom: 5,
								color: "red",
								zIndex: 1000,
								padding: "3px",
							}}
							onClick={() => {
								setIsShowPass(!isShowPass)
							}}>
							{isShowPass ? (
								<img
									src={hiddenImg}
									style={{ width: "24px", height: "16px" }}
								/>
							) : (
								<img
									src={showImg}
									style={{ width: "24px", height: "16px" }}
								/>
							)}
						</div>
					)}
					<input
						{...input}
						id={input.name}
						disabled={disabled}
						readOnly={readOnly}
						type={!isShowPass ? "password" : "text"}
						required={required}
						className={classNames("textbox textbox-secondary", className, {
							"textbox-secondary-error": isError,
						})}
					/>
					<label
						data-required={required}
						style={{
							fontSize: "15px",
							fontWeight: "400",
							lineHeight: "18px",
						}}
						htmlFor={input.name}
						className={classNames("textbox_label", labelClassName)}>
						{requiredIcon ? (
							<span>
								{label}
								<span style={{ color: "#D62B1F" }}>*</span>
							</span>
						) : (
							label
						)}
					</label>
				</div>
			</div>
		)
	}

	return secondary ? (
		<div className="textbox-container">
			<input
				{...input}
				id={input.name}
				disabled={disabled}
				readOnly={readOnly}
				type={type}
				required={required}
				className={classNames("textbox textbox-secondary", className, {
					"textbox-secondary-error": isError,
				})}
			/>
			<label
				style={{
					fontSize: "15px",
					fontWeight: "400",
					lineHeight: "18px",
				}}
				data-required={required}
				htmlFor={input.name}
				className={classNames("textbox_label", labelClassName, {
					"textbox_label-float": !isEmpty(input.value),
				})}>
				{requiredIcon ? (
					<span>
						{label}
						<span style={{ color: "#D62B1F" }}>*</span>
					</span>
				) : (
					label
				)}
			</label>
		</div>
	) : (
		<div className="textbox-container">
			<label
				data-required={required && !disabled}
				htmlFor={input.name}
				style={{
					fontSize: "15px",
					fontWeight: "400",
					lineHeight: "18px",
				}}
				className={classNames(
					"textbox_label textbox_label-primary",
					labelClassName,
					{ "d-none": hideLabel }
				)}>
				{requiredIcon ? (
					<span>
						{label}
						<span style={{ color: "#D62B1F" }}>*</span>
					</span>
				) : (
					label
				)}
			</label>
			<input
				{...input}
				id={input.name}
				required={required}
				disabled={disabled}
				readOnly={readOnly}
				type={type}
				pattern={pattern}
				maxLength={maxField}
				className={classNames("textbox textbox-primary", className, {
					"textbox-error": isError,
				})}
			/>
		</div>
	)
}

TextBox.propTypes = {
	input: PropTypes.object.isRequired,
	label: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	isError: PropTypes.bool,
	secondary: PropTypes.bool,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	hideLabel: PropTypes.bool,
	labelClassName: PropTypes.string,
	inputClassName: PropTypes.string,
}

export default TextBox



// WEBPACK FOOTER //
// ./src/views/components/forms/TextBox.js